import { render, staticRenderFns } from "./JeecgOrderCustomerList.vue?vue&type=template&id=8f22b984&scoped=true"
import script from "./JeecgOrderCustomerList.vue?vue&type=script&lang=js"
export * from "./JeecgOrderCustomerList.vue?vue&type=script&lang=js"
import style0 from "./JeecgOrderCustomerList.vue?vue&type=style&index=0&id=8f22b984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f22b984",
  null
  
)

export default component.exports